import { Backdrop, Box, CircularProgress, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import UserNavbar from "./UserNavbar";
import { Outlet } from "react-router-dom";
import UserSidebar from "./UserSidebar";
import { useOrganization } from "../../utils/OrganizationContext";

const UserDashboard = () => {
  const isMobile = useMediaQuery("(max-width: 750px)");
  const [projectId, setProjectId] = useState(
    JSON.parse(localStorage.getItem("projectId")) || "",
  );
  const { orgId, isSwitching } = useOrganization();
  
  return (
    <Box
      className="App"
      sx={{
        minHeight: "100vh",
        background: "#F4F7FA",
        color: "#0F1B2A",
        fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
      }}
    >
      <Box sx={{ display: "flex", minHeight: "100vh" }}>
        <UserSidebar />
        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0,
            maxWidth: "100%",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <UserNavbar projectId={projectId} setProjectId={setProjectId} />
          <Box sx={{ px: { xs: 2, md: 3 }, py: { xs: 2, md: 2.75 }, flex: 1 }}>
            <Outlet context={{ projectId }} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default UserDashboard;
